import React, {
  createContext,
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { VendorContext } from './VendorProvider';
import { UserContext } from './UserProvider';
import { userAxios, setupAxiosInterceptors } from '../userAxios';
const API_URL = process.env.REACT_APP_API_URL;
export const WebsiteContext = createContext();
const WebsiteProvider = (props) => {
  const debounceTimeout = useRef(null);
  const abortController = useRef(null);
  const { token, handleInvalidToken } = useContext(UserContext);
  const {
    getAllVendors,
    getVendorWebsites,
    selectedVendor,
    setSelectedVendor,
    setSelectedLocalVendor,
  } = useContext(VendorContext);
  const navigate = useNavigate();
  const [team, setTeam] = useState({ memberIds: [], members: [] });
  const [currentWebsiteID, setCurrentWebsiteID] = useState(null);
  const [sourceData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [websites, setWebsites] = useState([]);
  const [website, setWebsite] = useState({});
  const [broker] = useState({});
  const [comments, setComments] = useState([]);
  const [searchData, setSearchData] = useState({
    statuses: [],
    searchBox: '',
  });
  const [isTeamGroupWebsite, setIsTeamGroupWebsite] = useState(false);
  const [vendorWebsiteData, setVendorWebsiteData] = useState([]);
  const [callWebsiteForRefresh, setCallWebsiteForRefresh] = useState(false);
  const [vendorSearchResults, setVendorSearchResults] = useState([]);
  const [agentInfoLoading, setAgentInfoLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [websiteData, setWebsiteData] = useState(website);
  const [selectedWebsite, setSelectedWebsite] = useState(null);
  const [valid, setValid] = useState(true);
  const [inputValidity, setInputValidity] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [vendorSearch, setVendorSearch] = useState('');
  const [isVendorDropdownOpen, setVendorDropdownOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [reciprocal, setReciprocal] = useState(false);
  const [activity, setActivity] = useState([]);
  const [hasHistory, setHasHistory] = useState(false);
  const [hasTeam, setHasTeam] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [text, setText] = useState('');
  const [formKey, setFormKey] = useState(Math.random());
  const [products, setProducts] = useState([]);
  const [reciprocalAllowed, setReciprocalAllowed] = useState(false);
  const data = websites.map((website) => ({
    id: website.rowKey,
    vendor: website.vendor,
    domainName: website.domainName,
    licensee: website.licensee,
    firstName: website.firstName,
    lastName: website.lastName,
    Status: website.status,
    mlsStatus: website.mlsStatus,
    office: website.office,
    mlsId: website.mlsId,
    memberNumber: website.memberNumber,
    licenseNumber: website.licenseNumber,
    memberAOR: website.memberAOR,
    startDate: website.startDate,
    termDate: website.termDate,
    vendorCode: website.vendorCode,
    reciprocal: !!website.reciprocal,
    dba: website.dba,
    broker: {
      firstName: website.broker.firstName,
      lastName: website.broker.lastName,
      memberNumber: website.broker.memberNumber,
      licenseNumber: website.broker.licenseNumber,
      mlsId: website.broker.mlsId,
      office: website.broker.office,
      officeId: website.broker.officeId,
      status: website.broker.status,
    },
    documentsWaiting: website.documentsWaiting,
    voidedDocuments: website.voidedDocuments,
    products: website.products,
  }));
  const blankFormState = {
    vendor: '',
    domainName: '',
    licensee: '',
    firstName: '',
    lastName: '',
    status: 'Active',
    mlsStatus: '',
    office: '',
    mlsId: '',
    memberNumber: '',
    licenseNumber: '',
    termDate: '',
    startDate: new Date().toISOString().split('T')[0],
    vendorCode: '',
    reciprocal: false,
    memberAOR: '',
    dba: '',
    broker: {
      firstName: '',
      lastName: '',
      mlsId: '',
      memberNumber: '',
      office: '',
      licenseNumber: '',
      status: null,
    },
    documentsWaiting: undefined,
    products: [],
  };
  const [isFormChanged, setIsFormChanged] = useState(false);
  const checkFormChanged = (currentForm) => {
    return (
      JSON.stringify(currentForm) !==
      JSON.stringify({
        vendor: website.vendor || '',
        domainName: website.domainName || '',
        licensee: website.licensee || '',
        firstName: website.firstName || '',
        lastName: website.lastName || '',
        status: website.status || 'Active',
        mlsStatus: website.mlsStatus || '',
        office: website.office || '',
        mlsId: website.mlsId || '',
        memberNumber: website.memberNumber || '',
        licenseNumber: website.licenseNumber || '',
        termDate: website.termDate || '',
        startDate:
          website.startDate || new Date().toISOString().split('T')[0],
        vendorCode: website.vendorCode || '',
        reciprocal: website.reciprocal || false,
        memberAOR: website.memberAOR || '',
        dba: website.dba || '',
        broker: {
          firstName: website.broker?.firstName || '',
          lastName: website.broker?.lastName || '',
          mlsId: website.broker?.mlsId || '',
          memberNumber: website.broker?.memberNumber || '',
          office: website.broker?.office || '',
          licenseNumber: website.broker?.licenseNumber || '',
          status: website.broker?.status || null,
        },
        documentsWaiting: website.documentsWaiting || false,
        products: website.products || [],
      })
    );
  };
  const [form, setForm] = useState(blankFormState);
  useEffect(() => {
    setupAxiosInterceptors(handleInvalidToken);
  }, [handleInvalidToken]);
  const fetchAgentInfo = useCallback(
    async (name, isReciprocal, signal) => {
      try {
        setAgentInfoLoading(true);
        const endpoint = isReciprocal ? 'searchrecipagent' : 'searchagent';
        const response = await userAxios.get(
          `${API_URL}/${endpoint}/${name}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            signal,
          }
        );
        setSearchResults(response.data);
        setShowDropdown(response.data.length > 0);
        setValid(true);
        return response.data;
      } catch (error) {
        if (
          error.name === 'CanceledError' ||
          error.message === 'canceled'
        ) {
          return;
        }
        console.error('fetchAgentInfo error:', error);
        setValid(false);
        setInputValidity(
          isReciprocal
            ? 'Member was not found'
            : 'Member Number not found'
        );
      } finally {
        setAgentInfoLoading(false);
      }
    },
    [token]
  );
  const performSearch = useCallback(
    async (value, isReciprocal) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      if (abortController.current) {
        abortController.current.abort();
      }
      if (!value.trim()) {
        setSearchResults([]);
        setShowDropdown(false);
        return;
      }
      debounceTimeout.current = setTimeout(async () => {
        const controller = new AbortController();
        abortController.current = controller;
        await fetchAgentInfo(value, isReciprocal, controller.signal);
      }, 150);
    },
    [fetchAgentInfo]
  );
  const handleReciprocalToggle = () => {
    setReciprocal(!reciprocal);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...form };
    if (name.includes('.')) {
      const [parentName, propertyName] = name.split('.');
      if (!updatedForm[parentName]) {
        updatedForm[parentName] = {};
      }
      updatedForm[parentName][propertyName] = value;
    } else {
      updatedForm[name] = value;
    }
    setForm(updatedForm);
    if (name === 'agentSearch') {
      setDropdownOpen(true);
      performSearch(value, reciprocalAllowed ? reciprocal : false);
    } else if (name === 'vendor') {
      setVendorSearch(value);
    }
  };
  const getProducts = useCallback(async () => {
    try {
      const response = await userAxios.get(`${API_URL}/products`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      return [];
    }
  }, [token]);
  const getAllWebsites = useCallback(async () => {
    try {
      const response = await userAxios.get(`${API_URL}/websites`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setWebsites(response.data);
    } catch (error) {
      console.error('Error fetching websites:', error);
    }
  }, [token]);
  const getWebsite = async (rowKey) => {
    try {
      const response = await userAxios.get(
        `${API_URL}/websites/${rowKey}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        const websiteData = response.data;
        setWebsite(websiteData);
        setReciprocalAllowed(websiteData.reciprocalAllowed);
        return websiteData;
      }
      throw new Error('Error retrieving website data');
    } catch (error) {
      console.error('Error fetching website:', error);
      return null;
    }
  };
  const createWebsite = async (data) => {
    const response = await userAxios.post(
      API_URL + '/websites',
      { ...data, broker: { ...data.broker } },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.status !== 200 && response.status !== 201) {
      setText(`Error creating website`);
      setShowError(true);
      throw new Error('Error creating website');
    }
    setText('Website created successfully');
    setShowSuccess(true);
    const WebsiteData = await getWebsite(response.data);
    const imTheNewId = WebsiteData.rowKey;
    await getAllWebsites();
    setWebsiteData(WebsiteData);
    setWebsite(imTheNewId);
    await getActivity(imTheNewId);
    return WebsiteData;
  };
  const updateWebsite = async (data) => {
    const response = await userAxios.put(
      `${API_URL}/websites/${data.rowKey}`,
      { ...data, broker: { ...data.broker } },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.status !== 200) {
      setText(`Error updating website`);
      setShowError(true);
      throw new Error('Error updating website');
    }
    setText('Website updated successfully');
    setShowSuccess(true);
    await getAllWebsites();
    await getActivity(data.rowKey);
    return response.data;
  };
  const updateWebsiteField = (rowKey, updatedFields) => {
    setWebsites((prevWebsites) =>
      prevWebsites.map((website) =>
        website.rowKey === rowKey
          ? { ...website, ...updatedFields }
          : website
      )
    );
    if (websiteData?.rowKey === rowKey) {
      setWebsiteData((prev) => ({ ...prev, ...updatedFields }));
    }
  };
  const deleteWebsite = async (rowKey) => {
    try {
      setIsDeleting(true);
      const response = await userAxios.delete(
        `${API_URL}/websites/${rowKey}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setWebsites(
          websites.filter((website) => website.rowKey !== rowKey)
        );
        setVendorWebsiteData(
          vendorWebsiteData.filter(
            (website) => website.rowKey !== rowKey
          )
        );
        setSelectedWebsite(null);
        setForm(blankFormState);
        await getActivity(rowKey);
      } else {
        throw new Error('Error deleting website');
      }
    } catch (error) {
      console.error('Error deleting website:', error);
    } finally {
      setIsDeleting(false);
    }
  };
  const getWebsiteComments = useCallback(
    async (id) => {
      try {
        const response = await userAxios.get(
          `${API_URL}/website/${id}/comments`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setComments(response.data);
        return response.data;
      } catch (error) {
        console.error('Error fetching comments:', error);
      }
    },
    [token]
  );
  const getActivity = useCallback(
    async (id) => {
      try {
        const response = await userAxios.get(
          `${API_URL}/website/${id}/changelog`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.data) {
          setActivity(response.data);
          setHasHistory(response.data.length > 0);
        }
        return response.data;
      } catch (error) {
        console.error('Error fetching changelog:', error);
        setHasHistory(false);
      }
    },
    [token, setActivity, setHasHistory]
  );
  const getActivityDetails = async (websiteId, versionNumber) => {
    try {
      const response = await userAxios.get(
        `${API_URL}/website/${websiteId}/history/${versionNumber}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching activity details:', error);
      return null;
    }
  };
  const postComment = async (id, data) => {
    try {
      await userAxios.post(
        API_URL + '/website/' + id + '/comments',
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      await getWebsiteComments(id);
      await getActivity(id);
    } catch (error) {
      console.error('Error posting comment:', error);
    }
  };
  const deleteComment = async (id, commentId) => {
    try {
      await userAxios.delete(
        API_URL + '/website/' + id + '/comments/' + commentId,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      await getWebsiteComments(id);
      await getActivity(id);
    } catch (error) {
      console.error('Error deleting comment:', error);
    }
  };
  const sortChange = (fields) => {
    let sortedData = [...tableData];
    sortedData.sort((a, b) => {
      for (var param in fields) {
        if (fields[param]) {
          if (fields[param] === 'asc') {
            return ('' + a[param]).localeCompare(b[param]);
          } else if (fields[param] === 'desc') {
            return ('' + b[param]).localeCompare(a[param]);
          }
        }
      }
      return 0;
    });
    setTableData(sortedData);
  };
  const bulkUpdate = async (selectedRowKeys, bulkAction) => {
    let updatedArray = websites.filter((website) =>
      selectedRowKeys.includes(website.rowKey)
    );
    if (!['Active', 'Inactive'].includes(bulkAction)) {
      console.error('Invalid bulk action');
      return;
    }
    updatedArray = updatedArray.map((vendor) => {
      vendor.status = bulkAction;
      return vendor;
    });
    try {
      await userAxios.put(`${API_URL}/websites/bulk`, updatedArray, {
        headers: { Authorization: `Bearer ${token}` },
      });
      getAllVendors();
      await getActivity(selectedRowKeys[0]);
    } catch (error) {
      console.error('Error during bulk update:', error);
    }
  };
  const getWebsiteTeam = async (siteId, token) => {
    try {
      const response = await userAxios.get(
        `${API_URL}/websites/${siteId}/team`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching team:', error);
    }
  };
  const createWebsiteTeam = async (siteId, teamData, token) => {
    try {
      const response = await userAxios.post(
        `${API_URL}/websites/${siteId}/team`,
        teamData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating team:', error);
    }
  };
  const deleteWebsiteTeam = async (siteId, agentId, token) => {
    try {
      const response = await userAxios.delete(
        `${API_URL}/websites/${siteId}/team`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting team:', error);
    }
  };
  const updateWebsiteTeam = async (siteId, teamData, token) => {
    try {
      const response = await userAxios.put(
        API_URL + '/websites/' + siteId + '/team',
        teamData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating team:', error);
    }
  };
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    setCurrentWebsiteID(null);
    setSelectedVendor(null);
    setWebsite({});
    setComments([]);
    setActivity([]);
    setHasHistory(false);
    setReciprocal(false);
    setSelectedLocalVendor([]);
    navigate('/websites', { replace: true });
  };
  const headerToKeyMapping = {
    Vendor: 'vendor',
    Domain: 'domainName',
    Licensee: 'licensee',
    Status: 'Status',
    Office: 'office',
    'MLS ID': 'mlsId',
    'Member #': 'memberNumber',
    'MLS Status': 'mlsStatus',
    'Start Date': 'startDate',
    'Term Date': 'termDate',
  };
  useEffect(() => {
    const ignoreFields = ['rowKey', 'vendorId', 'reciprocal', 'broker'];
    const searchAll = () => {
      let filteredData = sourceData.filter((x) => {
        return (
          !searchData.statuses.length ||
          searchData.statuses.includes(x.status)
        );
      });
      filteredData = filteredData.filter((x) => {
        if (!searchData.searchBox.length) return true;
        for (const key in x) {
          if (x[key] === null || ignoreFields.includes(key)) continue;
          if (
            x[key]
              .toString()
              .toLowerCase()
              .includes(searchData.searchBox.toLowerCase())
          )
            return true;
        }
        return false;
      });
      setTableData(filteredData);
    };
    searchAll();
  }, [searchData, sourceData]);
  const refreshWebsites = async () => {
    try {
      const updatedData = await getVendorWebsites(selectedVendor.rowKey);
      setVendorWebsiteData(updatedData);
    } catch (error) {
      console.error('Failed to refresh websites: ', error);
    }
  };
  useEffect(() => {
    if (callWebsiteForRefresh) {
      setIsOpen(true);
      setFormKey((prevKey) => prevKey + 1);
    }
  }, [callWebsiteForRefresh]);
  const importWebsites = async (csvContent) => {
    try {
      const base64Content = btoa(csvContent);
      const payload = {
        type: 'website',
        data: base64Content,
      };
      const response = await userAxios.post(
        `${API_URL}/import`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setText('Data imported successfully');
      setShowSuccess(true);
      return response.data;
    } catch (error) {
      console.error('Error importing vendors:', error);
      setText('Error importing data');
      setShowError(true);
      throw error;
    }
  };
  return (
    <WebsiteContext.Provider
      value={{
        refreshWebsites,
        token,
        API_URL,
        showDropdown,
        setShowDropdown,
        valid,
        setValid,
        inputValidity,
        setInputValidity,
        agentInfoLoading,
        setAgentInfoLoading,
        currentWebsiteID,
        setCurrentWebsiteID,
        sourceData,
        tableData,
        vendorWebsiteData,
        setVendorWebsiteData,
        website,
        setWebsite,
        broker,
        comments,
        setComments,
        searchData,
        setSearchData,
        websites,
        isOpen,
        setIsOpen,
        data,
        isDeleting,
        websiteData,
        setWebsiteData,
        selectedWebsite,
        setSelectedWebsite,
        blankFormState,
        form,
        setForm,
        isFormChanged,
        setIsFormChanged,
        checkFormChanged,
        setDropdownOpen,
        reciprocal,
        setReciprocal,
        fetchAgentInfo,
        handleChange,
        isVendorDropdownOpen,
        setVendorDropdownOpen,
        vendorSearch,
        setVendorSearch,
        searchResults,
        setSearchResults,
        vendorSearchResults,
        setVendorSearchResults,
        getActivity,
        getActivityDetails,
        getWebsiteComments,
        handleReciprocalToggle,
        getAllWebsites,
        products,
        getProducts,
        getWebsiteTeam,
        deleteWebsiteTeam,
        createWebsiteTeam,
        updateWebsiteTeam,
        getWebsite,
        createWebsite,
        updateWebsite,
        updateWebsiteField,
        deleteWebsite,
        bulkUpdate,
        postComment,
        deleteComment,
        sortChange,
        openModal,
        closeModal,
        formKey,
        setFormKey,
        isDropdownOpen,
        activity,
        setActivity,
        headerToKeyMapping,
        hasHistory,
        setHasHistory,
        showSuccess,
        setShowSuccess,
        showError,
        setShowError,
        text,
        setText,
        callWebsiteForRefresh,
        setCallWebsiteForRefresh,
        reciprocalAllowed,
        setReciprocalAllowed,
        hasTeam,
        setHasTeam,
        isTeamGroupWebsite,
        setIsTeamGroupWebsite,
        team,
        setTeam,
        importWebsites,
        performSearch,
      }}
    >
      {props.children}
    </WebsiteContext.Provider>
  );
};
export default WebsiteProvider;